import { useEffect, useState } from 'react';
import Input from '../../../../components/Inputs/Input';
import './SupplyChain.css';


import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';

import { createStoresInfo, getStoresInfo, updateStoresInfo } from '../../services/StoresService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { SectionPlaceholder } from './SectionPlaceholder';
import engineeringImg from '../../../../assets/Images/engineering-placeholder.svg';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { InternalRepair } from './InternalRepair';
import { VendorsCost } from './VendorsCost';
import { VendorRepair } from './VendorRepair';
import { useDispatch } from 'react-redux';
import { resetSlice } from '../../../../redux/features/configuration/parts/vendorCostSlice';
import { createPart } from '../../services/PartsConfigurationService';

const generalSectionButtons = [
  { label: 'Save and Finish', icon: "icon-save", id: 'save' },
  { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
  { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];

const SupplyChain = ({ onChange, open, part, disabled }) => {

  const [editing, setEditing] = useState(false);
  const preferredVendorDropdown = useDropdownConfig(86);
  const [companyParameter, _] = useState([{ "columnName": "companyId", value: localStorage.getItem('u_company_id') }]);
  const [favVendorId, setFavVendor] = useState(null);



  const { infoMsg, successMsg, warningMsg } = useSnackBar();

  //FIXME: use actual permission context;


  //Form

  const [values, setValues] = useState({
    vendorId: part?.preferredVendor ?? null
  })
  const [backup, setBackup] = useState({
    vendorId: part?.preferredVendor ?? null
  })

  const hasPermission = () => {
    return true;
  }

  const saveSection = async (closeEdition) => {
    infoMsg("Saving Preferred Vendor");
    createPart({...part, preferredVendor: values.vendorId}).then(response => {
      if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
        if (closeEdition) {
          setEditing(false);
        }
        successMsg("Preferred Vendor Saved");
      } else {
        warningMsg(response.data.message);
      }
    })
    // infoMsg("Saving stores information");
    // if (typeof (values.id) !== 'number') {
    //   let postResponse = await createStoresInfo({ ...values, part }, part.id);
    //   if (postResponse.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
    //     updateStoresInfo({ ...postResponse.data.load, ...values, part }, part.id).then(updateResponse => {
    //       if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
    //         successMsg("Stores information saved");
    //         setValues(updateResponse.data.load);
    //         setBackup(updateResponse.data.load);
    //         if (closeEdition) setEditing(false);
    //       }
    //       else {
    //         warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
    //       }
    //     });
    //   }
    // } else {
    //   updateStoresInfo({ ...values, part }, part.id).then(updateResponse => {
    //     if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
    //       successMsg("Finance information saved");
    //       setValues(updateResponse.data.load);
    //       setBackup(updateResponse.data.load);
    //       if (closeEdition) setEditing(false);
    //     } else {
    //       warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
    //     }
    //   });
    // }
  }

  const cancelEdit = () => {
    setValues(backup);
    setEditing(false);
  }

  const changeValue = (e) => {
    let { name, value } = e;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  const handleDropdown = (opt, name) => {
    changeValue({ name, value: opt.id });
    // TODO: handle clear dropdowns;

  }

  useEffect(() => {
    setValues({
      vendorId: part?.preferredVendor ?? null
    });
    setBackup ({
      vendorId: part?.preferredVendor ?? null
    })
    // if (open && part) {
      
    // }
  }, [open, part])

  const dispatch = useDispatch();

  return (open &&
    <div className='supply-chain-wrapper'>
      <div className='section-header'>
        <div className='title-container'>
          <b>Supply Chain</b>
          {!editing && hasPermission('update') && (part?.version > 0) && <button className='outlined iconTextButton small-size' onClick={() => setEditing(true)}>
            <i className='icon-edit'></i>
            <span>
              Edit
            </span>
          </button>}
        </div>
        {editing && hasPermission('update') && <MultioptionButton buttonCallbacks={{
          'save': () => saveSection(true),
          'save-continue': () => saveSection(false),
          'cancel': () => cancelEdit()
        }} buttons={generalSectionButtons} />}
      </div>
      {part?.version > 0 ? <div className='supply-chain-form'>
        {/* <b className='subtitle'>Dimensions</b> */}
        {/* supply chain content */}
        <div className='vendor-card'>
          <b>Vendor Cost</b>
          <DialogTrigger dialogContent={{ component: VendorsCost, props: {part, costType: "C"}}} onCloseCallback={()=>{ dispatch(resetSlice({}))}}>
            <button className='outlined small-size'>
              <span>
                Configure Vendors Cost
              </span>
            </button>
          </DialogTrigger>
        </div>
        <div className='vendor-card'>
          <b>Internal Repair Capability</b>

          <DialogTrigger dialogContent={{ component: InternalRepair, props: {part} }}>
            <button className='outlined small-size'>
              <span>
                Configure Locations
              </span>
            </button>
          </DialogTrigger>
        </div>
        <div className='vendor-card'>
          <b>Vendor Repair Capability</b>
          <DialogTrigger dialogContent={{ component: VendorsCost, props: {part, costType: "R"} }} onCloseCallback={()=>{dispatch(resetSlice({}))}}>
            <button className='outlined small-size'>
              <span>
                Configure Vendor
              </span>
            </button>
          </DialogTrigger>
        </div>
        <Dropdowns preSelectValue={values.vendorId} onOptionSelect={opt => handleDropdown(opt, "vendorId")} disabled={!editing} optionLabel="name" iconPrefix="icon-favorite" data={preferredVendorDropdown.config} parameters={companyParameter} />
      </div>
        : <SectionPlaceholder title="There are no configurations in this panel" subTitle="Save the General Information to enable this section" image={engineeringImg} />

      }
    </div>
  )
}

export default SupplyChain;